var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M1 4h-1v-4h4v1h-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M12 1v-1h4v4h-1v-3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M15 12h1v4h-4v-1h3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M4 15v1h-4v-4h1v3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#828282",
    d: "M13 3v10h-10v-10h10zM14 2h-12v12h12v-12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewport);
export default __webpack_public_path__ + "static/media/viewport.42543cfc92c781f280c16a26f13e0f9e.svg";
export { ForwardRef as ReactComponent };